module.exports = __webpack_public_path__ + "static/media/alemanha.ff083eb6.JPG";